import { createAction, props } from '@ngrx/store';
import {TeacherRegistrationState} from '../state/teacher.registration.state';

export enum RegistrationActionTypes {
    SET_TSR_REG = '[TeacherRegistration] Set Teacher Registration',
}

export const loadTeacherRegistrationAction = createAction(RegistrationActionTypes.SET_TSR_REG, props<{ payload: TeacherRegistrationState }>());
